module.exports = __webpack_public_path__ + "static/media/number.b0fba773.svg";